import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// store
import { useStoreValue, storeSet } from '../../store';

// components
import { Toaster } from 'sonner';

const SimpleLayout = ({ children }) => {
    const isError404 = useStoreValue('isError404');
    const location = useLocation();

    useEffect(() => {
        storeSet('isError404', false);
    }, [location]);

    return (
        <main className="wrapper">
            {isError404
                ? <p>Error 404</p>
                : <>
                    {children}
                </>}
            <Toaster />
        </main>
    )
}

export default SimpleLayout;